/**
 * Tipos y helpers compartidos del selector de agencias (origen/destino). Vive aparte de los
 * componentes para no romper el fast-refresh (un archivo de componente solo debe exportar componentes).
 */

/** Title Case respetando separadores " ", "-" y "/" (formato Shalom). */
export const toTitle = (s: string) => s.toLowerCase().replace(/(?:^|\s|[-/])\S/g, (c) => c.toUpperCase());

export interface PickerAgency {
  id: string;
  name: string;
  address: string | null;
  department: string | null;
  province: string | null;
  distrito: string | null;
  categoria: string | null;
  /** Solo Shalom: la agencia admite envío aéreo (además del terrestre). */
  aereo?: boolean | null;
}

/** Ubigeo legible "Departamento / Provincia / Distrito" (formato Shalom). */
/** La búsqueda no distingue tildes ni mayúsculas: el catálogo de Olva dice «SAN ROMAN» y el drop escribe «San Román». */
const sinTildes = (s: string) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
export const coincideConLaBusqueda = (texto: string, busqueda: string) => sinTildes(texto).includes(sinTildes(busqueda.trim()));

export const ubigeoOf = (a: { department: string | null; province: string | null; distrito: string | null }) =>
  [a.department, a.province, a.distrito].filter((x): x is string => Boolean(x)).map(toTitle).join(' / ');
